import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { Metadata } from 'src/app/pago/models/Metadata.model';

export const getDatoDeConfiguracionPago = (
  configuracion: ConfiguracionDePago,
  datoABuscar: string
): string => {
  if (!configuracion) return;
  return configuracion.metadata.find(
    (metadata: Metadata) => metadata.dato === datoABuscar
  )?.valor;
};
